export default {
  lintOnSave: false,
  debug: true
}